module.exports = __webpack_public_path__ + "static/carousel1.6ebea9ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/carousel/carousel1.jpg
// module id = 705
// module chunks = 168707334958949